import React from 'react';
import PropTypes from 'prop-types';
import TextField from '../../_atomic/TextField/TextField';
import Button from '../../_atomic/Button/Button';
import { TEXT_FIELD_STATUS } from '../../../utils/constants';
import './UserInvoiceInfo.scss';


const propTypes = {
  invoiceMethod: PropTypes.shape({}).isRequired,
  clickChangeHandler: PropTypes.func.isRequired,
  isAdmin: PropTypes.bool,
};

const defaultProps = {
  isAdmin: false,
};

const UserInvoiceInfo = ({ invoiceMethod, clickChangeHandler, isAdmin }) => (
  <div className="user-invoice-info-wrapper">
    <TextField value={invoiceMethod.bankName} label="Bank name" status={TEXT_FIELD_STATUS.VALID} disabled />
    <TextField value={invoiceMethod.country} label="Country" status={TEXT_FIELD_STATUS.VALID} disabled />
    {!isAdmin &&
    <div className="button-wrapper">
      <Button label="Change" clickHandler={clickChangeHandler} secondary />
    </div>
    }
  </div>
);


UserInvoiceInfo.propTypes = propTypes;
UserInvoiceInfo.defaultProps = defaultProps;


export default UserInvoiceInfo;



// WEBPACK FOOTER //
// ./src/components/_molecules/UserInvoiceInfo/UserInvoiceInfo.js